'use client';
import { FC } from "react";
import cn from "classnames";
import Container from "@/layouts/Container.layout";
import { RichTextRenderer } from "@/components/RichTextRenderer/RichTextRenderer";
import Image from "@/components/Image/Image";
import { Button } from "@/components/Button/Button";
import { RichTextCardType } from "@/utils/strapi/sections/RichtextCard";
import { useRouter } from "next/navigation";
import Aspect from "@/components/Aspect/Aspect";

const RichtextCard: FC<RichTextCardType> = (props: RichTextCardType) => {
  const {
    bg_image_desktop,
    bg_image_mobile,
    richtext,
    position = "right",
    variant = "dark",
    card
  } = props;
  const router = useRouter();
  return (
    // @ts-ignore
    <div style={{ "--image-desk-url": `url(${bg_image_desktop?.url})`, "--image-tablet-url": `url(${bg_image_desktop?.url})`, "--image-mobile-url": `url(${bg_image_mobile?.url})` }}
      className={cn("w-full justify-center bg-origin-border md:bg-center bg-no-repeat bg-cover bg-secondary-0 py-24", "bg-[image:var(--image-mobile-url)]", "md:bg-[image:var(--image-tablet-url)]", "lg:bg-[image:var(--image-desk-url)]")}>
      <section>
      <Container>
        <div className={cn("flex space-y-6 items-center mobile:flex-col tablet:flex-col tablet:justify-center", { ["flex-row-reverse"]: position == "left" })}>
          <RichTextRenderer content={richtext} className={cn("!font-texts tablet:text-center",{ ["text-surface-0"]: variant == 'light', ["text-surface-950"]: variant == 'dark' })} />
          <div id="card" className="rounded-lg bg-surface-0 max-w-[591px] flex flex-col p-6 gap-6 shadow-md">
            <div className="flex items-start gap-6">
              <div className="flex flex-col space-y-6 ">
                <h4 className="font-texts font-bold text-xl">{card?.title}</h4>
                <RichTextRenderer className="mobile:hidden" content={card?.content} />
              </div>
              <div className="flex w-fit h-full">
                           {card?.circle_image && <div className="rounded-full overflow-hidden w-[108px] h-[108px]">
                <Aspect ratio="1/1">
                <Image classNames="rounded-full w-[108px] h-[108px]" src={card.circle_image?.url} alt={card.circle_image?.alternativeText || ""} />
                </Aspect>
              </div>}
              </div>   
            </div>
            <RichTextRenderer className="hidden mobile:flex" content={card?.content} />
            {card?.button && card.button.variant == 'primary' ? <Button
              type="button"
              intent='black'
              size='md'
              variant={'solid'}
              className="desktop:w-fit tablet:w-fit mobile:w-full bg-surface-950 border-surface-950 hover:border-surface-950 hover:bg-surface-0 hover:text-surface-950 text-surface-0"
              disabled={false}
              onClick={() => router?.push(card.button.CTA)}>{card.button.label}</Button> : card.button && <Button
                id="cta-banner"
                type="button"
                intent='black'
                size='md'
                variant={'solid'}
                className="desktop:w-fit tablet:w-fit mobile:w-full bg-transparent border-surface-950 hover:bg-surface-950 hover:text-surface-0 text-surface-950"
                disabled={false}
                onClick={() => router?.push(card.button.CTA)}>{card.button.label}</Button>}
          </div>
        </div>
      </Container>
      </section>
    </div>
  )
}

export default RichtextCard;